import { Mode } from "@/types";

export const Modes: Record<string, Mode> = {
  Analysis: {
    key: "analysis",
    name: "Analyse",
    check: groups => groups.includes("tool:analysis"),
    view: "analysis-view"
  },
  Encode: {
    key: "encode",
    name: "Encode",
    check: groups => groups.includes("tool:encode"),
    view: "encode-view"
  },
  Live: {
    key: "live",
    name: "Live",
    check: groups => groups.includes("tool:live"),
    view: "live-view"
  },
  Timeline: {
    key: "timeline",
    name: "Timeline",
    check: groups => groups.includes("tool:timeline"),
    view: "timeline-view"
  },
  Verify: {
    key: "verify",
    name: "Verify",
    check: groups => groups.includes("verify"),
    view: "verify-view"
  },
  MSA: {
    key: "msa",
    name: "MSA",
    check: groups => groups.includes("msa"),
    view: "msa-view"
  },
  Lien: {
    key: "lien",
    name: "Lien",
    check: groups => groups.includes("lien"),
    view: "lien-view"
  },
  NewTimeline: {
    key: "new-timeline",
    name: "New Timeline",
    check: groups => groups.includes("tool:new-timeline"),
    view: "new-timeline-view"
  }
};
